import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MeasurementSystem } from '@seddi/core';

export type UserPreferencesState = {
  unitSystem: MeasurementSystem;
  name?: string;
  lastName?: string;
  title?: string;
  email?: string;
  displayName?: string;
  photoURL?: string;
  phoneNumber?: string;
};

export type UserState = UserPreferencesState & {
  userId?: string;
  permission?: string;
  role?: string;
  admin?: boolean;
};

export type UserUnitsAction = {
  type: string;
  payload: MeasurementSystem;
};

const initialState: UserState = {
  unitSystem: MeasurementSystem.Imperial,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserPreferences: (
      state: UserState,
      action: PayloadAction<Partial<UserPreferencesState>>,
    ) => {
      if (action.payload.displayName) state.displayName = action.payload.displayName;
      if (action.payload.name) state.name = action.payload.name;
      if (action.payload.lastName) state.lastName = action.payload.lastName;
      if (action.payload.unitSystem) state.unitSystem = action.payload.unitSystem;
      if (action.payload.title) state.title = action.payload.title;
      if (action.payload.email) state.email = action.payload.email;
      if (action.payload.photoURL) state.photoURL = action.payload.photoURL;
      if (action.payload.phoneNumber) state.phoneNumber = action.payload.phoneNumber;
    },
    setUserId: (state: UserState, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    setRole: (state: UserState, action: PayloadAction<string>) => {
      state.role = action.payload;
    },
    setPermission: (state: UserState, action: PayloadAction<string>) => {
      state.permission = action.payload;
    },
    setAdmin: (state: UserState, action: PayloadAction<boolean>) => {
      state.admin = action.payload;
    },
    setName: (state: UserState, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setLastName: (state: UserState, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setDisplayName: (state: UserState, action: PayloadAction<string>) => {
      state.displayName = action.payload;
    },
    setTitle: (state: UserState, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setUnitSystem: (state: UserState, action: UserUnitsAction) => {
      state.unitSystem = action.payload;
    },
    setPhoneNumber: (state: UserState, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
  },
});

export const {
  setUserPreferences,
  setUserId,
  setRole,
  setPermission,
  setAdmin,
  setName,
  setLastName,
  setDisplayName,
  setTitle,
  setUnitSystem,
  setPhoneNumber,
} = userSlice.actions;

export const userReducer = userSlice.reducer;
